import React, { useEffect, useState } from 'react';
export function StickyAddToCart() {
  const [showProductOptions, setShowProductOptions] = useState(false);
  // Check if product options are visible
  useEffect(() => {
    const checkProductOptionsVisibility = () => {
      const productOptionsSection = document.getElementById('product-options');
      setShowProductOptions(!!productOptionsSection);
    };
    // Check initially
    checkProductOptionsVisibility();
    // Set up an interval to check periodically
    const intervalId = setInterval(checkProductOptionsVisibility, 1000);
    return () => clearInterval(intervalId);
  }, []);
  const scrollToProductOptions = () => {
    // Check if product options section exists
    const productOptionsSection = document.getElementById('product-options');
    if (productOptionsSection) {
      // If it exists, scroll to it
      productOptionsSection.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      // If it doesn't exist yet (hidden due to timer), show a message
      alert('Our special offers will be available soon! Please continue watching the video.');
      // Scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 py-3 px-4" data-id="element-373">
      <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-374">
        <div className="flex items-center" data-id="element-375">
          <div className="mr-3" data-id="element-376">
            <p className="font-bold text-sm md:text-base" data-id="element-377">
              Hair Growth Oil 3.0
            </p>
            <p className="text-xs text-gray-600" data-id="element-378">Ancient Indonesian Formula</p>
          </div>
        </div>
        <button onClick={scrollToProductOptions} className="bg-orange-600 hover:bg-orange-700 text-white font-bold py-2 px-6 rounded" data-id="element-379">
          {showProductOptions ? 'Add To Cart' : 'Learn More'}
        </button>
      </div>
    </div>;
}
export default {
  StickyAddToCart
};